import agencyURL from './agencyURL';

const nonWordChars = new RegExp('[^\\w]+', 'g');

const agentURL = (agent, agency, tab) => {
  //agency/<agency-name>-<location>/<agencyID>/<agent-name>/<agent-id>(/for_sale|/for_rent)?
  let agent_url = agencyURL(agency);
  let agentName = 'NoAgentName';
  if (agent.name) agentName = agent.name;
  else {
    if (agent.firstName && agent.lastName) agentName = agent.firstName + '-' + agent.lastName;
    else {
      if (agent.firstName) agentName = agent.firstName;
      else if (agent.lastName) agentName = agent.lastName;
    }
  }
  agentName = agentName.replace(nonWordChars, '-');
  agent_url = agent_url + '/' + agentName + '/' + agent.uuid;
  if (tab) agent_url = agent_url + '/' + tab;
  return agent_url.toLowerCase();
}
export default agentURL;
